import React from "react";
import { Link } from "react-router-dom";

// Point terracotta rond du logo
export function OrganicDot({ className = "" }) {
  return (
    <svg viewBox="0 0 40 40" className={className} aria-hidden="true">
      <circle cx="20" cy="20" r="18" fill="#c98a63" />
    </svg>
  );
}

export default function Logo({ light = false, size = "md", asLink = true }) {
  const big = size === "lg";
  const Wrap = asLink ? Link : "span";
  const wrapProps = asLink ? { to: "/", "data-testid": "logo-link", "aria-label": "Ouest Conciergerie - Accueil" } : { "data-testid": "hero-logo" };
  const ink = light ? "text-[#faf7f0]" : "text-[#13261c]";
  return (
    <Wrap {...wrapProps} className="group relative inline-flex flex-col items-stretch leading-none select-none">
      <span className="flex items-end">
        <span className={`font-logo font-black tracking-[-0.025em] ${big ? "text-[64px] sm:text-[84px]" : "text-[38px]"} ${ink}`} style={{ lineHeight: 0.9 }}>
          ouest
        </span>
        <OrganicDot className={`${big ? "w-[14px] h-[14px] sm:w-[18px] sm:h-[18px] mb-[6px] sm:mb-[8px]" : "w-[9px] h-[9px] mb-[3px]"} ml-[2px] transition-transform duration-500 group-hover:scale-125 group-hover:-translate-y-0.5`} />
      </span>
      <span aria-hidden="true" className={`font-caps flex justify-between ${big ? "text-[15px] sm:text-[19px] mt-3 sm:mt-4" : "text-[9px] mt-[6px]"} ${ink}`} style={{ lineHeight: 1 }}>
        {"CONCIERGERIE".split("").map((l, i) => <span key={i}>{l}</span>)}
      </span>
      <span className="sr-only">Conciergerie</span>
    </Wrap>
  );
}
